export const AccidentDetails = {
  AIR_BAGS: 'The air bags came out',
  SEAT_BELT: 'I was wearing my seat belt',
  TOOK_AMBULANCE: 'I was taken in an ambulance',
  VISIT_ER: 'I went to the emergency room',
  OTHER_TREATMENT: 'I received other treatment',
  OTHER_PEOPLE: 'Other people were in the car with me'
}
